export default {
  "PAGES": {
    "LOGIN_PAGE": {
      "LOGIN": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Accedi"])},
      "REMEMBER_ME": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricordami"])},
      "ALREADY_HAVE_NOT_ACCOUNT": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non hai un account?"])},
      "SIGNUP": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Iscriviti"])}
    }
  },
  "MODALS": {
    
  },
  "VALIDATIONS": {
    
  }
}